/** Shared hover highlight style for scanning navigation.
 *  Apply via spread when the item is the active hovered element. */
export const hoverHighlightSx = {
    outline: '6px solid #1a237e',
    outlineOffset: 8,
};
